(function () {
  if (window.__collapsibleContentInitialized) return;

  window.__collapsibleContentInitialized = true;

  $("body").on("click", ".collapsible-content__toggle", function () {
    const element = $(this);
    const parent = element.parent();

    if (!parent.hasClass("active")) {
      parent.siblings(".collapsible-content__item.active").removeClass("active");
      parent.addClass("active");
      element
        .closest(".collapsible-content__items")
        .find(".collapsible-content__answer")
        .stop()
        .slideUp(300);
      element.next().stop().slideDown(300);
    } else {
      parent.removeClass("active");
      element.next().stop().slideUp(300);
    }
  });

  $("body").on("mouseenter", ".collapsible-content__item", function () {
    const element = $(this);
    element.removeClass("collapsible-content__item--opacity");
    element.siblings().addClass("collapsible-content__item--opacity");
    element.mouseleave(() => {
      element.siblings().removeClass("collapsible-content__item--opacity");
    });
  });
})();

